import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { IconButton } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import Grid from '../../grid/grid';
import Dialog from '../../dialog/Dialog';
import Form from '../Form';
import { FieldType } from '../Form.models';
import TextField from './Text';
import { Subject } from 'rxjs';
import classnames from 'classnames';
/**
 * Получения значения из объекта. Поддерживает точечную нотацию
 * @param obj
 * @param param
 */

var getFromObject = function getFromObject(obj, param) {
  if (typeof param === 'string') {
    param = param.split('.');
  }

  return param.length === 1 ? obj[param[0]] || '' : getFromObject(obj[param[0]], param.slice(1));
};
/**
 * Состояние инициализации
 */


var initialState = {
  opened: false,
  selected: undefined,
  loaded: false,
  filterParams: undefined,
  order: undefined
};

var FindComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FindComponent, _React$Component);

  function FindComponent(props) {
    var _this;

    _classCallCheck(this, FindComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FindComponent).call(this, props));
    _this.gridEvents = new Subject();
    /**
     * Открытие модального окна поиска
     */

    _this.onOpen = function () {
      if (!_this.props.disabled) {
        _this.setState({
          opened: true
        });
      }
    };
    /**
     * Закрытие модального окна поиска
     */


    _this.onClose = function () {
      _this.setState(initialState);
    };
    /**
     * Сабмит формы поиска
     * @param values
     * @param cb
     */


    _this.onSubmit = function (values, cb) {
      _this.setState({
        loaded: true,
        filterParams: values
      }, function () {
        _this.gridEvents.next('update');

        cb && cb();
      });
    };
    /**
     * Выбор строки в гриде
     * @param selected
     */


    _this.onGridSelect = function (selected) {
      _this.setState({
        selected: selected
      });
    };
    /**
     * Сохранение выбранной строки
     * @param _event
     */


    _this.saveSelected = function (_event) {
      var selected = _this.state.selected;

      if (selected) {
        var _this$props = _this.props,
            onFieldChange = _this$props.onFieldChange,
            id = _this$props.id,
            field = _this$props.field;
        onFieldChange(id || field.name, selected);

        _this.onClose();
      }
    };
    /**
     * Очистка значения
     */


    _this.clear = function (event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
      var _this$props2 = _this.props,
          onFieldChange = _this$props2.onFieldChange,
          id = _this$props2.id,
          field = _this$props2.field,
          disabled = _this$props2.disabled;

      if (!disabled) {
        onFieldChange(id || field.name, undefined);
      }
    };
    /**
     * Заглушка обработки изменения значения текстового поля
     */


    _this.onFieldChange = function () {// do nobaseg
    };
    /**
     * Возвращает строку из данных объекта согласнопереданному шаблону
     */


    _this.getStringValueFromObject = function () {
      var _this$props3 = _this.props,
          field = _this$props3.field,
          value = _this$props3.value;

      if (value && field.params && field.params.visibleTextTemplate) {
        var objectValue = value;
        return field.params.visibleTextTemplate.replace(/\$\{(.+?)\}/g, function (match, param) {
          return getFromObject(objectValue, param);
        });
      }

      return '';
    };
    /**
     * После сброса формы
     */


    _this.afterResetForm = function () {
      _this.setState({
        loaded: false
      });
    };

    _this.state = initialState;
    return _this;
  }

  _createClass(FindComponent, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          id = _this$props4.id,
          field = _this$props4.field,
          classes = _this$props4.classes,
          slim = _this$props4.slim,
          disabled = _this$props4.disabled;

      if (field.params && field.params.form && field.params.grid && field.params.url) {
        var _this$state = this.state,
            opened = _this$state.opened,
            order = _this$state.order,
            loaded = _this$state.loaded,
            filterParams = _this$state.filterParams;
        var _field$params = field.params,
            fields = _field$params.form.fields,
            _field$params$grid = _field$params.grid,
            columns = _field$params$grid.columns,
            queryParamsAdapter = _field$params$grid.queryParamsAdapter,
            responseDataAdapter = _field$params$grid.responseDataAdapter,
            url = _field$params.url;
        var buttons = [{
          label: 'Применить',
          func: this.saveSelected,
          onlySelected: true
        }];
        var inputValue = this.getStringValueFromObject();

        var fieldProps = _objectSpread({}, this.props, {
          field: _objectSpread({}, field, {
            type: FieldType.Text
          }),
          value: inputValue
        });

        return React.createElement(React.Fragment, null, React.createElement("div", {
          className: classes.fieldContainer
        }, React.createElement(TextField, Object.assign({}, fieldProps, {
          onFieldChange: this.onFieldChange
        })), React.createElement("div", {
          className: classnames(classes.findFieldButton, disabled ? classes.findFieldButtonDisabled : ''),
          onClick: this.onOpen
        }, inputValue && React.createElement(IconButton, {
          className: classnames(classes.clearButton, _defineProperty({}, classes.clearButtonSlim, slim)),
          size: slim ? 'small' : 'medium',
          "aria-label": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u043B\u0435",
          onClick: this.clear,
          disabled: disabled
        }, React.createElement(Clear, {
          fontSize: slim ? 'small' : 'default'
        })))), opened && React.createElement(Dialog, {
          open: true,
          onClose: this.onClose,
          title: field.label,
          disableEnforceFocus: true,
          slim: slim
        }, React.createElement("div", {
          className: classes.modalFormWrapper
        }, React.createElement(Form, {
          fields: fields,
          onSubmit: this.onSubmit,
          type: 'find',
          onCloseModal: this.onClose,
          afterReset: this.afterResetForm,
          slim: slim
        })), loaded && React.createElement("div", {
          className: classnames(classes.modalGridWrapper, _defineProperty({}, classes.modalGridWrapperSlim, slim))
        }, React.createElement(Grid, {
          id: "".concat(id || field.name, "_grid"),
          title: '',
          columns: columns,
          url: url,
          order: order,
          hideFilter: true,
          buttons: buttons,
          externalFilter: filterParams,
          onSelect: this.onGridSelect,
          events: this.gridEvents,
          transformFilter: queryParamsAdapter,
          transformResult: responseDataAdapter,
          slim: slim
        }))));
      }

      return null;
    }
  }]);

  return FindComponent;
}(React.Component);

var Find = function Find(props) {
  return React.createElement(FindComponent, Object.assign({}, props));
};

export default Find;